import React, { Component } from 'react';
import { Table } from 'antd';
import moment from 'moment';

import { CaseMainTitle } from '../../components/newDesign/CaseMainTitle';
import { MainWrapper } from '../../components/newDesign/MainWrapper/MainWrapper';
import { getUserAccessAttempts } from '../../services/api';

export default class Profile extends Component {
  state = {
    user: null,
    attempts: [],
    loading: false,
  };

  componentDidMount() {
    let user = window.localStorage.getItem('user_params');

    if (user) {
      try {
        user = JSON.parse(user);
      } catch (e) {
        user = null;
      }
    }

    if (user && user.userId) {
      this.setState({ user, loading: true }, () => {
        getUserAccessAttempts(user.userId)
          .then((data) => {
            const attempts = Array.isArray(data) ? data : [];
            this.setState({ attempts, loading: false });
          })
          .catch(() => {
            this.setState({ loading: false });
          });
      });
    } else {
      this.setState({ user: user || null });
    }
  }

  get columns() {
    return [
      {
        title: 'Дата и время',
        dataIndex: 'attemptDate',
        key: 'attemptDate',
      },
      {
        title: 'IP-адрес',
        dataIndex: 'ipAddress',
        key: 'ipAddress',
      },
      {
        title: 'Тип',
        dataIndex: 'type',
        key: 'type',
      },
      {
        title: 'Система',
        dataIndex: 'system',
        key: 'system',
      },
      {
        title: 'Успешно',
        dataIndex: 'successText',
        key: 'successText',
      },
      {
        title: 'Описание',
        dataIndex: 'description',
        key: 'description',
      },
    ];
  }

  mapAttemptsToRows() {
    const { attempts } = this.state;

    return attempts.map((a) => ({
      key: a.id, // для AntD
      attemptDate: a.attemptDate ? moment(a.attemptDate).format('DD.MM.YYYY HH:mm:ss') : '',
      ipAddress: a.ipAddress || '',
      type: a.type || '',
      system: a.system || '',
      successText: a.success ? 'Да' : 'Нет',
      description: a.description || '',
    }));
  }

  render() {
    const { user, loading } = this.state;
    const rows = this.mapAttemptsToRows();

    return (
      <MainWrapper>
        <CaseMainTitle>Профиль пользователя</CaseMainTitle>

        {user && (
          <div style={{ marginBottom: 20 }}>
            <div>
              <strong>Имя пользователя:</strong> {user.username}
            </div>
            <div>
              <strong>ID пользователя:</strong> {user.userId}
            </div>
            {user.roles && user.roles.length > 0 && (
              <div>
                <strong>Роль:</strong> {user.roles[0].name}
              </div>
            )}
          </div>
        )}

        {!user && (
          <div style={{ marginBottom: 20 }}>
            Не удалось прочитать данные пользователя из localStorage.
          </div>
        )}

        <Table
          columns={this.columns}
          dataSource={rows}
          loading={loading}
          pagination={{ pageSize: 10 }}
          scroll={{ y: '50vh' }}
        />
      </MainWrapper>
    );
  }
}
